import { AppState } from 'src/store';

export const selectRecentSearches = (state: AppState) => state.search;
